import * as React from 'react';
import {ClientBookmark} from "../../../../domain/model/client_bookmark";
import {Customer} from "../../../../domain/model/customer";
import ScoutCustomerCard from "../../../common/organism/card/scout_customer_card";
import styled from "styled-components";
import {TJobCareerWithCustomerID} from "../../../../domain/repository/job_career_repository";
import {JobCareer} from "../../../../domain/model/job_career";

interface IProps {
    clientBookmarks: ClientBookmark[];
    customers: Customer[];
    jobCareersWithCustomerID: TJobCareerWithCustomerID[],
}

const ClientClientBookmarksMain: React.FC<IProps> = (props) => {

    const {clientBookmarks, customers, jobCareersWithCustomerID} = props;

    // Customerの連想配列を作成し、MessageRoomから連携させる。
    const hashCustomer: { [customerId: string]: Customer; } = {};
    for (const item of customers) {
        hashCustomer[item.id] = item;
    }

    // customerId: JobCareer[]の連想配列を作成し連携させる。
    const hashJobCareer: { [customerId: string]: JobCareer[]; } = {};
    for (const item of jobCareersWithCustomerID) {
        hashJobCareer[item.customerID] = item.jobCareers;
    }

    const res: JSX.Element = (
        <React.Fragment>
            {
                clientBookmarks.map((clientBookmark: ClientBookmark) => {
                    const customer: Customer | undefined = hashCustomer[clientBookmark.customerID];
                    if (!customer) {return null};
                    const customerId: string = customer.id;
                    const jobCareers: JobCareer[] | undefined = hashJobCareer[customerId];
                    if (!jobCareers) {return null};
                    const isBookmarked: boolean = clientBookmark.customerID === customerId;
                    return (
                        <ScoutCustomerCardWrapper key={customerId}>
                            <ScoutCustomerCard
                                customer={customer}
                                jobCareers={jobCareers}
                                isBookmarked={isBookmarked}
                                cardURL={`/client/scout/customer/${customerId}`}
                            />
                        </ScoutCustomerCardWrapper>
                        )
                })
            }
        </React.Fragment>

    );

    return (res);

};

export default ClientClientBookmarksMain;

const ScoutCustomerCardWrapper = styled.div`
    margin-bottom: 40px;
`;


// WEBPACK FOOTER //
// ./src/presentation/component/client/client_bookmarks/client_bookmarks_main.tsx